<template>
  <div
      class="ui-selectmenu-block ui-front"
      :class="{'ui-selectmenu-open': open}"
  >
    <div class="ui-selectmenu-menu">
      <ul class="ui-menu minimal-select-menu">
        <li v-if="state" class="ui-menu-item">
          <div class="ui-menu-item-wrapper ui-state-active">
            {{ state }}
          </div>
        </li>
        <li
            class="ui-menu-item no-results"
            v-for="(item, index) in items"
            :key="item.id || index"
            @click.stop="selected(item)"
        >
          <div class="ui-menu-item-wrapper" :data-id="item.id">
            {{ item.title || item.name }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { cleanSelectionOptions } from '../api/adminBrands'

export default {
  props: {
    id: null,
    open: null,
    data: null,
    state: null,
    queryItem: null,
  },
  computed: {
    items() {
      return cleanSelectionOptions(this.data)
    },
  },
  methods: {
    selected(item) {
      this.unbindOutsideClick();
      this.$emit('selected', { item });
      this.$emit('open', { enabled: false });
    },
    unbindOutsideClick() {
      document.body.removeEventListener('click', this.handleClick, false);
    },
    handleClick(event) {
      if (!event.target.closest(`[select-item="${this.id}"]`)) {
        this.unbindOutsideClick();
        this.$emit('open', { enabled: false });
      }
    },
    matchesQuery(item) {
      const needle = this.queryItem
      if (needle == null || needle === '' || !item) return false
      if (item.id == needle) return true
      const right = String(needle).trim().toLowerCase()
      const id = String(item.id ?? '').trim().toLowerCase()
      const title = String(item.title || item.name || '').trim().toLowerCase()
      return right !== '' && (id === right || title === right)
    },
    selectItem(data) {
      (data || []).forEach(item => {
        if (this.matchesQuery(item)) this.selected(item)
      });
    }
  },
  watch: {
    open: function(value) {
      this.unbindOutsideClick();
      if (value) {
        document.body.addEventListener('click', this.handleClick, false);
      }
    },
    data: function(value) {
      if (this.queryItem && value) this.selectItem(this.items)
    }
  },
  beforeDestroy() {
    this.unbindOutsideClick();
  },
}
</script>